<template>
  <div>
    <span v-if="selectedWarnType === 10" class="com-pc-card-title pl-4"
      >基準観測所{{ annTime }}</span
    >
    <span v-if="selectedWarnType !== 10" class="com-pc-card-title pl-4"
      >基準観測所{{ annTime }}</span
    >
    <v-sheet class="rw-box-obs">
      <!-- 予警報詳細データがない場合 -->
      <div v-if="!selectedRwDetailRwFlg">
        <v-list
          class="pa-0"
          light
          v-for="(obs, obsIdx) in selectedRwDetailMt.stgObs"
          :key="obsIdx"
        >
          <v-list-item
            class="river-warn-list-line"
            @click="clickObs(obs.ofcCd, obs.itmkndCd, obs.obsCd)"
          >
            <v-list-item-content class="pl-4">
              <v-list-item-title>{{ obs.obsNm }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <!-- 予警報詳細データがある場合 -->
      <div v-if="selectedRwDetailRwFlg">
        <v-list
          class="pa-0"
          light
          v-for="(obs, obsIdx) in selectedRwDetailRw.stgobs"
          :key="obsIdx"
        >
          <v-list-item
            class="river-warn-list-line"
            @click="clickObs(obs.ofcCd, obs.itmkndCd, obs.obsCd)"
          >
            <v-list-item-content class="pl-2">
              <v-list-item-title class="rw-line-nm"
                ><span class="rw-line-obsnm"
                  >{{ obs.obsNm }}{{ obsNmKana(obs) }}{{ obsTwnNm(obs) }}</span
                ></v-list-item-title
              >
              <v-list-item-subtitle class="rw-line-stg">
                <!--零点高から -->
                <span
                  class="rw-item-stg pr-2"
                  v-if="
                    stgMode === '0' || (stgMode === '1' && obs.dspFlg === 2)
                  "
                >
                  {{ stgMsg.normalStg }} {{ formatStg(obs.stg) }}m
                </span>
                <!--堤防高から -->
                <div
                  class="rw-item-stg pr-2"
                  v-if="stgMode === '1' && obs.dspFlg === 1"
                >
                  {{ stgMsg.topendStg }} {{ formatStg(obs.stgHght) }}m
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon class="rw-item-status">
              <div
                v-if="obs.stgOvlvl === 10"
                class="text-flood-standby rw-status"
              >
                {{ text.standby }}
              </div>
              <div v-if="obs.stgOvlvl === 30" class="text-flood-warn rw-status">
                {{ text.warn }}{{ config.messageConfig.alertLvl.stgLvl2 }}
              </div>
              <div
                v-if="obs.stgOvlvl === 60"
                class="text-flood-refuge rw-status"
              >
                {{ text.refuge }}{{ config.messageConfig.alertLvl.stgLvl3 }}
              </div>
              <div
                v-if="obs.stgOvlvl === 80"
                class="text-flood-danger rw-status"
              >
                {{ text.danger }}{{ config.messageConfig.alertLvl.stgLvl4 }}
              </div>
              <div
                v-if="obs.stgOvlvl === 90"
                class="text-flood-occurrence rw-status"
              >
                {{ text.occurrence }}
              </div>
            </v-list-item-icon>
            <v-list-item-icon
              v-if="selectedWarnType === 10 && obs.stgOvlvl >= 30"
              class="rw-item-tendency"
            >
              <object
                class="rv-img"
                :id="'pred_tendency_' + obsIdx"
                type="image/svg+xml"
                :data="predTendencyUrl"
              ></object>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import mixin from "./../../lib/mixin.js";
import Util from "./../../lib/util.js";
export default {
  name: "rw-obs",
  mixins: [mixin],
  data() {
    return {
      text: {
        standby: "水防団待機水位超過",
        warn: "氾濫注意水位超過",
        refuge: "避難判断水位超過",
        danger: "氾濫危険水位超過",
        occurrence: "氾濫開始水位超過",
      },
    };
  },
  computed: {
    /**
     * 選択中予警報種別
     */
    selectedWarnType: {
      get() {
        return this.$store.state.RiverWarn.selectedWarnType;
      },
    },
    /**
     * 選択中河川予警報詳細
     */
    selectedRwDetailRw: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rw[
          this.$store.state.RiverWarn.selectedAnnIdx
        ];
      },
    },
    /**
     * 選択中河川予警報マスタ
     */
    selectedRwDetailMt: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.mt;
      },
    },
    /**
     * 予測水位の矢印
     */
    predTendencyUrl: {
      get() {
        let url = "/kawabou/img/pred_tendency.svg";
        return url;
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 水位表示切替メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
    /**
     * 選択中河川予警報フラグ
     */
    selectedRwDetailRwFlg: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rwFlg;
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /** 発表時刻 */
    annTime: {
      get() {
        if (!this.selectedRwDetailRw || !this.selectedRwDetailRw.annTime) {
          return "";
        } else {
          let time = Util.formatDate(
            this.selectedRwDetailRw.annTime,
            "MM/DD HH:mm"
          );
          return "（" + time + "時点の観測値）";
        }
      },
    },
  },
  /**
   * マウント後イベント
   */
  mounted() {
    // 予測水位の矢印描画
    this.$log.debug("[RwObs] mounted");
    setTimeout(() => {
      this.drawPredTendency();
    }, 1500);
  },
  watch: {
    /** 選択中河川予警報詳細変更時 */
    selectedRwDetailRw() {
      this.$log.debug("[RwObs] watch selectedRwDetailRw()");
      setTimeout(() => {
        // 予測水位の矢印描画
        this.drawPredTendency();
      }, 1500);
    },
  },
  methods: {
    /** 個別観測所画面へ遷移 */
    clickObs(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[RwObsJson] clickObs(" + ofcCd + "," + itmkndCd + "," + obsCd + ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: Number(ofcCd),
        itmkndCd: Number(itmkndCd),
        obsCd: Number(obsCd),
      });
      // 画面遷移
      this.routerPushTm("/pc/tm");
    },
    /** 予測水位の矢印描画 */
    drawPredTendency() {
      this.$log.debug("[RwObs] drawPredTendency()");
      // 洪水予報以外の場合は描画しない
      if (this.selectedWarnType !== 10) {
        return;
      }
      if (
        this.selectedRwDetailRw &&
        this.selectedRwDetailRw.stgobs.length > 0
      ) {
        // 予測水位のSVGを描画
        for (let idx = 0; idx < this.selectedRwDetailRw.stgobs.length; idx++) {
          let info = this.selectedRwDetailRw.stgobs[idx];
          // 水位が30（氾濫注意水位）未満の場合はSVGを表示しない
          if (info.stgOvlvl < 30) {
            continue;
          }
          // 予測水位の最大値を取得
          // let maxStg = null;
          // let minStg = null;
          let maxStg = info.stg;
          let minStg = info.stg;
          if (info.predstg[0]) {
            // let crntStg = info.predstg[0].stg;
            let crntStg = info.stg;
            for (let pIdx = 0; pIdx < info.predstg.length; pIdx++) {
              let stg = Number(info.predstg[pIdx].stg);
              if (maxStg == null) {
                maxStg = stg;
              } else if (maxStg < stg) {
                maxStg = stg;
              }
              if (minStg == null) {
                minStg = stg;
              } else if (minStg > stg) {
                minStg = stg;
              }
            }

            // x,yの座標算出用のポイント
            let xp = 350 / (info.predstg.length + 1);
            let yp = "";
            if (maxStg === minStg) {
              yp = 150;
            } else {
              yp = 150 / (maxStg - minStg);
            }

            // 矢印のライン描画用にpathを成形
            // let stgD = "M";
            let stgD =
              "M" + 10 + "," + (150 - (info.stg - minStg) * yp + 10) + " ";
            for (let pIdx = 0; pIdx < info.predstg.length; pIdx++) {
              let stg = Number(info.predstg[pIdx].stg);
              stgD +=
                (pIdx + 1) * xp +
                10 +
                "," +
                (150 - (stg - minStg) * yp + 10) +
                " ";
            }
            let fillColor = "blue";
            if (crntStg < maxStg) {
              fillColor = "red";
            }

            const elmE = document.getElementById("pred_tendency_" + idx);
            const elm = elmE.contentDocument;
            const arrow = elm.getElementById("arrow");
            arrow.style.setProperty("fill", fillColor);
            const g_line = elm.getElementById("g_line");
            g_line.style.setProperty("stroke", fillColor);
            const line = elm.getElementById("line");
            line.setAttribute("d", stgD);
          } else {
            const elmE = document.getElementById("pred_tendency_" + idx);
            const elm = elmE.contentDocument;
            const line = elm.getElementById("line");
            line.setAttribute("d", "");
          }
        }
      }
    },
    /**
     * 水位を小数第2位に変換
     */
    formatStg(stg) {
      this.$log.debug("[RwObs] formatStg(" + stg + ")");
      return Util.formatFloat(stg, 2);
    },
    /**
     * 観測所の市町村名
     */
    obsNmKana(obsInfo) {
      this.$log.debug("[RwObs] obsNmKana(obsInfo)");
      let obsNmKana = "";
      for (let stgObs of this.selectedRwDetailMt.stgObs) {
        if (obsInfo.obsFcd === stgObs.obsFcd) {
          if (stgObs.twnNm) {
            obsNmKana = "（" + stgObs.obsNmKana + "）";
          }
          break;
        }
      }
      return obsNmKana;
    },
    /**
     * 観測所の市町村名
     */
    obsTwnNm(obsInfo) {
      this.$log.debug("[RwObs] obsTwnNm(obsInfo)");
      let twnNm = "";
      for (let stgObs of this.selectedRwDetailMt.stgObs) {
        if (obsInfo.obsFcd === stgObs.obsFcd) {
          if (stgObs.twnNm) {
            twnNm = "【" + stgObs.twnNm + "】";
          }
          break;
        }
      }
      return twnNm;
    },
  },
};
</script>

<style lang="scss" scoped>
.rw-box-obs {
  overflow: hidden;
  .overview-icon {
    min-width: 32px;
  }
  .rw-line-nm {
    display: flex;
    flex-direction: row;
    .rw-line-obsnm {
      flex: 1;
      font-size: 0.9rem;
      white-space: pre-wrap;
    }
  }
  .rw-line-stg {
    display: flex;
    flex-direction: row;

    .rw-item-stg {
      width: 150px;
      font-size: 0.8rem;
      text-align: center;
      color: black;
    }
  }
  .rw-item-status {
    width: 180px;
    .rw-status {
      margin-top: 8px;
      font-size: 10pt;
      font-weight: bold;
      display: inline-block;
      padding: 2px 4px 4px 2px;
      border-radius: 6px;
    }
  }
  .rw-item-tendency {
    height: 36px;
    .rv-img {
      width: 34pt;
    }
  }
}
</style>
